import React from 'react'

const BuyerStatement = () => {
  return (
    <div>
       Buyer Statement
    </div>
  )
}

export default BuyerStatement
